
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController, ModalController, AlertController, NavController } from '@ionic/angular';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { UtilService } from '../../../../service/util.service';
import { UserProfile } from '../../../../models/user-profile.model';
import { ReportCashierComponent } from '../../../../component/advanced-filter/report-cashier/report-cashier.component';
import { ReportCashierCounterListComponent } from '../../../../component/report-cashier-counter-list/report-cashier-counter-list.component';
import * as XLSX from 'xlsx';
import { ReportService } from '../../report.service';
import { ReportCashierType, TransactionType } from '../../../../enum/ReportCashierType';
import { UserData } from '../../../../providers/user-data';
import { RoleAccess } from '../../../../models/role-access.model';
import { ReportCashierBranchListComponent } from '../../../../component/report-cashier-branch-list/report-cashier-branch-list.component';
import { VoidTransactionComponent } from '../../../../component/void-transaction/void-transaction.component';

@Component({
  selector: 'app-report-cashier-v2',
  templateUrl: './report-cashier-v2.page.html',
  styleUrls: ['./report-cashier-v2.page.scss'],
})
export class ReportCashierV2Page implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  userAccess: any[] = [];
  formCashierReport: FormGroup;
  branchData: any[] = [];
  counterData: any[] = [];
  spgData: any[] = [];
  cashierData: any[] = [];
  userData: any[] = [];
  reportData: any[] = [];
  brandData: any[] = [];
  typeData: any[] = [];
  customerResellerData: any[] = [];
  reportType: any = null;

  dateStart: any;
  dateEnd: any;
  idCounter: any = 'null';
  idBranch: any= 'null';
  idCashier: any = 'null';
  idUser: any = 'null';
  noReceipt: any = 'null';
  typeId: any = 'null';
  transactionType: any;
  resellerId: any = 'null';
  spgId:any='';

  branchName: any;
  counterName: any;
  cashierName: any;
  userName: any;
  typeName: any;
  resellerName: any;
  transactionTypeName: any;
  rekapPerName: any;
  paymentName:any;
  paymentType:any=0;
  stickerNumber:any='';

  tempIndex: any = 0;
  tempReceiptNumber: any = '0';

  paramBranchId: any;
  paramCounterId: any;
  paramCashierId: any;
  paramUserId: any;
  paramTransactionTypeId: any;
  paramRekapPer: any;
  paramPeriodStart: any;
  paramPeriodEnd: any;
  paramReceiptNumber: any;
  paramTypeId: any;
  paramResellerId: any;
  paramPaymentType:any;
  paramSpgId:any;
  fileName= 'ReportKasir.xlsx';
  typeReport = ReportCashierType;
  typeTransaction = TransactionType;
  typeReportList = Object.keys(ReportCashierType).filter(
    typeReport => typeof this.typeReport[typeReport] === 'number'
  );
  typeTransactionList = Object.keys(TransactionType).filter(
    typeTransaction => typeof this.typeTransaction[typeTransaction] === 'number'
  );
  
  roleAccess = new RoleAccess();
  showBtnCounterList: boolean = false;
  showBtnBranchList: boolean = false;
  counterListForShow: any[] = [];
  branchListForShow:any[] =[];
  sumQty: number = 0;
  sumBruto: number = 0;
  sumDiscount: number = 0;
  sumNetto: number = 0;
  sumTax: number =0;
  sumPembulatan:number=0;
  sumTotal:number=0;
  void_type_id:Number=0;
  replacementReceipt=0;
  picList: any[] = [];
  specialVoidAccess:boolean=false;

  constructor(
    private fb: FormBuilder,
    private storage: Storage,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private modalController: ModalController,
    private reportService: ReportService,
    private alertController: AlertController,
    private router: Router,
    private userDataProvider: UserData,
    private navCtrl:NavController
  ) { }

  ngOnInit() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userAccess = access;
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          this.userProfile = new UserProfile(profile);
          let counterId = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
          this.paymentName = 'Semua';
          this.stickerNumber ='';
          let options = { 
            "token": this.token,
            "counter_id": counterId
          };
          this.reportService.getReportCashierIndex(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            this.cashierData = response.results.cashier_data;
            this.branchData = response.results.branch_data;
            this.counterData = response.results.counter_data;
            this.spgData = response.results.spg_data;
            this.userData = response.results.user_data;
            this.typeData = response.results.type_data;
            this.customerResellerData = response.results.reseller_data;
            this.roleAccess = this.userDataProvider.checkAccess(this.router.url, this.userAccess, this.userProfile);
            let branchId='';
            if(this.branchData.length>0){
              for(let i = 0; i < this.branchData.length; i++) {
                if(branchId === '') {
                  branchId = this.branchData[i].id;
                } else {
                  branchId = branchId + ', ' + this.branchData[i].id;
                }
              }
            }
            this.picList = response.results.pic;
            let employeeId = this.userProfile.employee_id;
            let roleId = this.userProfile.role_id;
            let checkRole = this.picList.find(
              (x) => x.based_on == "role" && x.role_id == roleId
            );
            if (checkRole) {
              this.specialVoidAccess = true;
            }
            let checkEmployee = this.picList.find(
              (x) => x.based_on == "employee" && x.employee_id == employeeId
            );
            if (checkEmployee) {
              this.specialVoidAccess = true;
            }
            this.generateReport(branchId,counterId, '', '', '0', '0', new Date(), new Date(), '', '', '','0','');
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        });
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  exportToExcel() {
    /* table id is passed over here */   
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  buildFormReportCashier() {
    let todayDate = new Date();
    let convertDate = this.utilService.convertDate(todayDate);
    let transDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;

    this.formCashierReport = this.fb.group({
      transactionTypeId: ['0'],
      rekapPer: ['0'],
      periodStart: [transDate],
      periodEnd: [transDate],
      receiptNumber: [],
      counterId: [],
      cashierId: []
    });
  }

  generateReport(branchId:any,counterId: any, cashierId: any, userId: any,
    transactionTypeId: any, rekapPer: any, periodStart: any, periodEnd: any, receiptNumber: any,
    typeId: any, resellerId: any,paymentType:any,spgId:any) {
    this.setParamReport(branchId,counterId, cashierId, userId, transactionTypeId, rekapPer, periodStart, periodEnd, receiptNumber, typeId, resellerId,spgId);
    let startDate = new Date(periodStart);
    let endDate = new Date(periodEnd);
    let convertDateStart = this.utilService.convertDate(startDate);
    let convertDateEnd = this.utilService.convertDate(endDate);
    this.dateStart = convertDateStart.years + '-' + convertDateStart.months + '-' + convertDateStart.dates;
    this.dateEnd = convertDateEnd.years + '-' + convertDateEnd.months + '-' + convertDateEnd.dates;
    this.idBranch = branchId !== 'undefined' && branchId !== '' ? branchId : 'null';
    this.idCounter = counterId !== 'undefined' && counterId !== '' ? counterId : 'null';
    
    this.idCashier = cashierId !== 'undefined' && cashierId !== '' ? cashierId : 'null';
    this.idUser = userId !== 'undefined' && userId !== '' ? userId : 'null';
    this.noReceipt = receiptNumber !== 'undefined' && receiptNumber !== '' ? receiptNumber : 'null';
    this.typeId = typeId !== 'undefined' && typeId !== '' ? typeId : 'null';
    this.resellerId = resellerId !== 'undefined' && resellerId !== '' ? resellerId : 'null';
    this.paymentType = paymentType !== 'undefined' && paymentType !== '' ? paymentType : '0';
    this.spgId = spgId !== 'undefined' && spgId !== '' ? spgId : '0';
    this.reportType = rekapPer;
    this.transactionType = transactionTypeId;

    this.rekapPerName = this.typeReportList[rekapPer];
    this.transactionTypeName = this.typeTransactionList[transactionTypeId];
    this.paymentName = 'Semua';
    this.sumQty = 0;
    this.sumNetto = 0;
    this.sumTax = 0;
    this.sumPembulatan = 0;
    this.sumBruto = 0;
    this.sumDiscount = 0;
    this.sumTotal = 0;
    if(this.paymentType=='1'){
      this.paymentName = 'Tunai';
    }
    else if(this.paymentType=='2'){
      this.paymentName = 'Non Tunai';
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.void_type_id=0;
      this.replacementReceipt=0;
      let options = {
        "token": this.token,
        "start_date": this.dateStart,
        "end_date": this.dateEnd,
        "branch_id":this.idBranch,
        "counter_id": this.idCounter,
        "cashier_id": this.idCashier,
        "user_id": this.idUser,
        "receipt_no": this.noReceipt,
        "type_id": this.typeId,
        "transaction_type": this.transactionType,
        "reseller_id": this.resellerId,
        "payment_type":this.paymentType,
        "spg_id":this.spgId
      };

      this.reportService.getReportCashier(rekapPer, options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          let cashierData: any = response.cashier_data;
          let userData: any = response.user_data;
          let typeData: any = response.type_data;
          let resellerData: any = response.reseller_data;
          this.counterListForShow = response.counter_data;
          this.branchListForShow = response.branch_data;
          this.reportData = response.results;
          this.branchData =this.branchListForShow;
          let spgData: any = response.spg_data;
          if(this.counterListForShow.length > 0) {
            let loopCounter = 0;
            if(this.counterListForShow.length > 5) {
              loopCounter = 5;
              this.showBtnCounterList = true;
            } else {
              loopCounter = this.counterListForShow.length;
              this.showBtnCounterList = false;
            }
            this.counterName = '';
            for(let i = 0; i < loopCounter; i++) {
              if(this.counterName === '') {
                this.counterName = this.counterListForShow[i].counter_name;
              } else {
                this.counterName = this.counterName + ', ' + this.counterListForShow[i].counter_name;
              }
            }
          } else {
            this.counterName = 'Data Not Found';
          }
          
          if(this.branchListForShow.length > 0) {
            let loopBranch = 0;
            if(this.branchListForShow.length >5) {
              loopBranch = 5;
              this.showBtnBranchList = true;
            } else {
              loopBranch = this.branchListForShow.length;
              this.showBtnBranchList = false;
            }

            this.branchName = '';
            for(let i = 0; i < loopBranch; i++) {
              if(this.branchName === '') {
                this.branchName = this.branchListForShow[i].branch_name;
              } else {
                this.branchName = this.branchName + ', ' + this.branchListForShow[i].branch_name;
              }
            }
          } else {
            this.showBtnBranchList = false;
            this.branchName = 'Data Not Found';
          }
          
          this.typeName = typeData.length > 0 ? typeData[0].product_type_name : 'Data Not Found';
          if(cashierData.length > 0) {
            let loopCashier = 0;
            loopCashier = cashierData.length;
            this.cashierName = '';
            for(let i = 0; i < loopCashier; i++) {
              if(this.cashierName === '') {
                this.cashierName = cashierData[i].cashier_name;
              } else {
                this.cashierName = this.cashierName + ', ' + cashierData[i].cashier_name;
              }
            }
          } else {
            this.cashierName = 'Data Not Found';
          }

          if(userData.length > 0) {
            let loopUser = 0;
            loopUser = userData.length;
            this.userName = '';
            for(let i = 0; i < loopUser; i++) {
              if(this.userName === '') {
                this.userName = userData[i].name;
              } else {
                this.userName = this.userName + ', ' + userData[i].name;
              }
            }
          } else {
            this.userName = 'Data Not Found';
          }
          
          if(spgData.length > 0) {
            let loopSpg = 0;
            loopSpg = spgData.length;
            this.stickerNumber = '';
            for(let i = 0; i < loopSpg; i++) {
              if(this.stickerNumber === '') {
                this.stickerNumber = spgData[i].spg_name;
              } else {
                this.stickerNumber = this.stickerNumber + ', ' + spgData[i].spg_name;
              }
            }
          } else {
            this.stickerNumber = '';
          }

          this.resellerName = resellerData.length > 0 ? resellerData[0].referral_code + ' - ' + resellerData[0].customer_name : 'Data Not Found';
          let res = response.results;
          if(rekapPer === '0' || rekapPer === '5') {
            if(this.paymentType=='1'){
              res = response.results.filter(x=>parseInt(x.tunai)>0);
            }
            else if(this.paymentType=='2'){
              res = response.results.filter(x=>parseInt(x.tunai)==0);
            }
            this.reportData = res;
            if(this.reportData.length>0){
              for(let rd = 0;rd<this.reportData.length;rd++){
                let discount = Math.floor(this.reportData[rd].discount/1.11);
                let grand_total = this.reportData[rd].grand_total;

                let netto = Math.ceil(grand_total / 1.11);
                let tax = Math.floor(netto * 0.11);
                let bruto = netto + discount;
                this.reportData[rd].discount = discount;
                this.reportData[rd].bruto = bruto;
                this.reportData[rd].netto = netto;
                this.reportData[rd].tax =tax;
                this.reportData[rd].grand_total = grand_total;
              }
            }
            this.countTotalReportTransaction(res);
          } else if(rekapPer === '1') {
            if(this.paymentType=='1'){
              res = response.results.filter(x=>parseInt(x.tunai)>0);
            }
            else if(this.paymentType=='2'){
              res = response.results.filter(x=>parseInt(x.tunai)==0);
            }
            this.reportData = res;
            if(this.reportData.length>0){
              for(let rd = 0;rd<this.reportData.length;rd++){
                let tax = 1.11;
                let price_exc_ppn = Math.round(this.reportData[rd].price/tax);
                let disc = Math.round(this.reportData[rd].disc/tax);
                let bruto = Math.round(this.reportData[rd].qty * price_exc_ppn);
                let netto = bruto - disc;
                this.reportData[rd].disc = disc;
                this.reportData[rd].price_exc_ppn= price_exc_ppn;
                this.reportData[rd].bruto = bruto;
                this.reportData[rd].netto = netto;
                this.reportData[rd].tax = Math.round(netto*0.11)
                let beforePembulatan =  netto +this.reportData[rd].tax;
                let pembulatan = this.reportData[rd].total-beforePembulatan;
                this.reportData[rd].pembulatan = pembulatan;
              }
            }
            this.countTotalReportTransactionDetail(res);
          } else if(rekapPer === '3' || rekapPer === '8') {
            this.reportData = res;
            if(this.reportData.length>0){
              let reportDataOri = JSON.parse(JSON.stringify(this.reportData));
              for(let rd = 0;rd<this.reportData.length;rd++){
                let tax = 1.11;
                let price_exc_ppn = Math.floor(this.reportData[rd].price/tax);
                let disc = Math.floor(this.reportData[rd].total_disc/tax);

                let bruto =0;
                if(rekapPer === '8'){
                  bruto = Math.ceil(this.reportData[rd].bruto/tax);
                }
                else{
                  bruto = ((this.reportData[rd].total_qty-this.reportData[rd].total_free_qty)* price_exc_ppn);
                }
                let netto = bruto - disc;
                this.reportData[rd].disc = disc;
                this.reportData[rd].price_exc_ppn= price_exc_ppn;
                this.reportData[rd].bruto = bruto;
                this.reportData[rd].netto = netto;
                this.reportData[rd].tax = Math.floor(netto*0.11)
                
                let pembulatan = reportDataOri[rd].netto -(netto +this.reportData[rd].tax);
                this.reportData[rd].pembulatan = pembulatan;
                
                this.reportData[rd].total = netto +this.reportData[rd].tax+pembulatan;
              }
            }
            this.countTotalReportTransactionBrand(res);
          } else if(rekapPer === '2' || rekapPer === '7') {
            this.reportData = res;
            let reportDataOri = JSON.parse(JSON.stringify(this.reportData));
            if(this.reportData.length>0){
              for(let rd = 0;rd<this.reportData.length;rd++){
                let tax = 1.11;
                let price_exc_ppn = Math.floor(this.reportData[rd].price/tax);
                let disc = Math.ceil(this.reportData[rd].disc/tax);
                let bruto =0;
                if(rekapPer === '7'){
                  bruto = Math.ceil(this.reportData[rd].bruto/tax);
                }
                else{
                  bruto = (this.reportData[rd].qty * price_exc_ppn);
                }
                let netto = bruto - disc;
                let totalTax = Math.floor(netto*0.11);
                this.reportData[rd].disc = disc;
                this.reportData[rd].price_exc_ppn= price_exc_ppn;
                this.reportData[rd].bruto = bruto;
                this.reportData[rd].netto = netto;
                this.reportData[rd].tax = totalTax;
                let pembulatan = reportDataOri[rd].netto -(netto +this.reportData[rd].tax);
                let report = this.reportData[rd];
                this.reportData[rd].pembulatan = pembulatan;
                let totalAkhir = report.netto+report.tax+report.pembulatan
                this.reportData[rd].total =totalAkhir;
              }
            }
            this.countTotalReportTransactionProduct(res);
          }
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  clearFilter() {
    this.generateReport('','', '', '', '0', this.paramRekapPer, this.paramPeriodStart, this.paramPeriodEnd, '', '', '','0','');
  }

  async openAdvancedFilters() {
    const modal = await this.modalController.create({
      component: ReportCashierComponent,
      componentProps: {
        cashierList: this.cashierData,
        branchList: this.branchData,
        counterList: this.counterData,
        spgList: this.spgData,
        userList: this.userData,
        typeList: this.typeData,
        customerResellerList: this.customerResellerData,
        paramBranchId: this.paramBranchId,
        paramCounterId: this.paramCounterId,
        paramCashierId: this.paramCashierId,
        paramUserId: this.paramUserId,
        paramTransactionTypeId: this.paramTransactionTypeId,
        paramRekapPer: this.paramRekapPer,
        paramPeriodStart: this.paramPeriodStart,
        paramPeriodEnd: this.paramPeriodEnd,
        paramReceiptNumber: this.paramReceiptNumber,
        paramTypeId: this.paramTypeId,
        paramResellerId: this.paramResellerId,
        paramPaymentType:this.paymentType,
        paramSpgId:this.paramSpgId
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      if (data !== 'null') {
        let splitData = data.split('#');
        if(splitData[0] === '0' || splitData[0] === '1') {
          this.generateReport(splitData[9],splitData[5], splitData[6], splitData[7], splitData[0], splitData[1],
            splitData[2], splitData[3], splitData[4], splitData[8], '', splitData[10], splitData[11]);
        }
        if(splitData[0] === '2') {
          this.generateReport(splitData[10],splitData[5], splitData[6], splitData[7], splitData[0], splitData[1],
            splitData[2], splitData[3], splitData[4], splitData[8], splitData[9], splitData[10], splitData[11]);
        }
      }
    });
    return await modal.present();
  }

  countTotalReportTransaction(report: any) {
    let counterId: any = '';
    let sumTotal: number = 0, sumDiscount: number = 0, sumNetto: number = 0, sumTaxBasis: number = 0,
    sumGrandTotal: number = 0, sumTunai: number = 0, sumCredit: number = 0, sumDebit: number = 0, sumTransfer: number = 0,
    sumValasUSD: number = 0, sumValasCNY: number = 0, sumValasWNY: number = 0, sumVoucher: number = 0,
    sumTotalBayar: number = 0, sumKembali: number = 0, sumNetTunai: number = 0, sumMemberPoint: number = 0, sumReward: number = 0,sumPaymentVoucher:number=0,sumBruto:number=0,sumPembulatan=0;

    let counterIdCount: number = 0;
    let arrSumData: any[] = [];
    for(let i = 0; i < report.length; i++) {
      let tempCounterId = report[i].counter_id;
      if(i === 0) { counterId = report[i].counter_id; }
      if(counterId === tempCounterId) {
        sumBruto = sumBruto + parseInt(report[i].bruto);
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumNetto = sumNetto + parseInt(report[i].netto);
        sumTaxBasis = sumTaxBasis + parseInt(report[i].tax);
        sumGrandTotal = sumGrandTotal + parseInt(report[i].grand_total);
        sumNetTunai = sumNetTunai + parseInt(report[i].nettunai);
        sumPaymentVoucher= sumPaymentVoucher + parseInt(report[i].payment_voucher);
        sumTunai = sumTunai + parseInt(report[i].tunai);
        sumCredit = sumCredit + parseInt(report[i].credit_card);
        sumDebit = sumDebit + parseInt(report[i].debit_card);
        sumTransfer = sumTransfer + parseInt(report[i].transfer);
        sumValasUSD = sumValasUSD + parseInt(report[i].valas_usd);
        sumValasCNY = sumValasCNY + parseInt(report[i].valas_cny);
        sumValasWNY = sumValasWNY + parseInt(report[i].valas_wny);
        sumVoucher = sumVoucher + parseInt(report[i].voucher);
        sumMemberPoint = sumMemberPoint + parseInt(report[i].member_point);
        sumReward = sumReward + parseInt(report[i].reward);
        sumTotalBayar = sumTotalBayar + parseInt(report[i].total_bayar);
        sumKembali = sumKembali + parseInt(report[i].kembali);
        sumPembulatan = sumPembulatan + parseInt(report[i].pembulatan);
        if((i+1) === report.length) {
          counterIdCount = counterIdCount + 1;
          let indexInsert = i + counterIdCount;
          let data = {
            id: '0',
            counter_id: counterId,
            counter_name: report.length==1 ? report[0].counter_name:report[i-1].counter_name,
            sum_total: sumTotal,
            sum_bruto:sumBruto,
            sum_discount: sumDiscount,
            sum_netto: sumNetto,
            sum_tax_basis: sumTaxBasis,
            sum_grand_total: sumGrandTotal,
            sum_nettunai: sumNetTunai,
            sum_payment_voucher: sumPaymentVoucher,
            sum_tunai: sumTunai,
            sum_credit: sumCredit,
            sum_debit: sumDebit,
            sum_transfer: sumTransfer,
            sum_valas_usd: sumValasUSD,
            sum_valas_cny: sumValasCNY,
            sum_valas_wny: sumValasWNY,
            sum_voucher: sumVoucher,
            sum_memberpoint: sumMemberPoint,
            sum_reward: sumReward,
            sum_total_bayar: sumTotalBayar,
            sum_kembali: sumKembali,
            index_insert: indexInsert,
            sum_pembulatan:sumPembulatan
          };
          arrSumData.push(data);
        }
      } else {
        let indexInsert = i + counterIdCount;
        counterIdCount = counterIdCount + 1;
        let data = {
          id: '0',
          counter_id: counterId,
          counter_name: report[i-1].counter_name,
          sum_total: sumTotal,
          sum_discount: sumDiscount,
          sum_netto: sumNetto,
          sum_tax_basis: sumTaxBasis,
          sum_grand_total: sumGrandTotal,
          sum_nettunai: sumNetTunai,
          sum_payment_voucher: sumPaymentVoucher,
          sum_tunai: sumTunai,
          sum_credit: sumCredit,
          sum_debit: sumDebit,
          sum_transfer: sumTransfer,
          sum_valas_usd: sumValasUSD,
          sum_valas_cny: sumValasCNY,
          sum_valas_wny: sumValasWNY,
          sum_voucher: sumVoucher,
          sum_memberpoint: sumMemberPoint,
          sum_reward: sumReward,
          sum_total_bayar: sumTotalBayar,
          sum_kembali: sumKembali,
          index_insert: indexInsert,
          sum_pembulatan:sumPembulatan
        };
        arrSumData.push(data);
        //start new sum for next counter
        sumTotal = 0; sumDiscount = 0; sumNetto = 0; sumTaxBasis = 0; sumGrandTotal = 0;
        sumNetTunai = 0; sumTunai = 0; sumCredit = 0; sumDebit = 0; sumTransfer = 0; sumValasUSD = 0; 
        sumValasCNY = 0; sumValasWNY = 0; sumVoucher = 0; sumMemberPoint = 0; sumReward = 0;
        sumTotalBayar = 0; sumKembali = 0;
        sumTotal = sumTotal + parseInt(report[i].total);
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumNetto = sumNetto + parseInt(report[i].netto);
        sumTaxBasis = sumTaxBasis + parseInt(report[i].tax_basis);
        sumGrandTotal = sumGrandTotal + parseInt(report[i].grand_total);
        sumNetTunai = sumNetTunai + parseInt(report[i].nettunai);
        sumTunai = sumTunai + parseInt(report[i].tunai);
        sumCredit = sumCredit + parseInt(report[i].credit_card);
        sumDebit = sumDebit + parseInt(report[i].debit_card);
        sumTransfer = sumTransfer + parseInt(report[i].transfer);
        sumValasUSD = sumValasUSD + parseInt(report[i].valas_usd);
        sumValasCNY = sumValasCNY + parseInt(report[i].valas_cny);
        sumValasWNY = sumValasWNY + parseInt(report[i].valas_wny);
        sumVoucher = sumVoucher + parseInt(report[i].voucher);
        sumMemberPoint = sumMemberPoint + parseInt(report[i].member_point);
        sumReward = sumReward + parseInt(report[i].reward);
        sumTotalBayar = sumTotalBayar + parseInt(report[i].total_bayar);
        sumKembali = sumKembali + parseInt(report[i].kembali);
        sumPembulatan = sumPembulatan+parseInt(report[i].pembulatan);
        //end new sum for next counter
        counterId = tempCounterId;
      }
    }

    for(let x = 0; x < arrSumData.length; x++) {
      let indexInsert: number = arrSumData[x].index_insert;
      this.reportData.splice(indexInsert, 0, arrSumData[x]);
    }
  }

  countTotalReportTransactionDetail(report: any) {
    let receiptNumber: any = '';
    let sumBruto: number = 0, sumDiscount: number = 0, sumNetto: number = 0, sumCharge: number = 0,
    sumTax: number = 0, sumPembulatan:number=0,sumTotal: number = 0;
    let receiptNumberCount: number = 0;
    let arrSumData: any[] = [];
    let lastCount = report.length - 1;
    let arrGt: any[] = [];

    for(let i = 0; i < report.length; i++) {
      let tempReceiptNumber = report[i].receipt_no;
      if(i === 0) {
        receiptNumber = report[i].receipt_no;
        sumBruto = sumBruto + parseInt(report[i].bruto);
        sumDiscount = sumDiscount + parseInt(report[i].disc);
        sumNetto = sumNetto + parseInt(report[i].netto);
        sumTax = sumTax + parseInt(report[i].tax);
        sumTotal = sumTotal + parseInt(report[i].total);
        sumPembulatan = sumPembulatan + parseInt(report[i].pembulatan);
      } else {
        if(receiptNumber === report[i].receipt_no) {
          sumBruto = sumBruto + parseInt(report[i].bruto);
          sumDiscount = sumDiscount + parseInt(report[i].disc);
          sumNetto = sumNetto + parseInt(report[i].netto);
          sumTax = sumTax + parseInt(report[i].tax);
          sumTotal = sumTotal + parseInt(report[i].total);
          sumPembulatan = sumPembulatan + parseInt(report[i].pembulatan);
        } else {
          let indexInsert = i + receiptNumberCount;
          receiptNumberCount = receiptNumberCount + 1;
          let data = {
            id: '0',
            receipt_no: receiptNumber,
            sum_bruto: sumBruto,
            sum_discount: sumDiscount,
            sum_netto: sumNetto,
            sum_charge: sumCharge,
            sum_tax: sumTax,
            sum_pembulatan: sumPembulatan,
            sum_total: sumTotal,
            index_insert: indexInsert
          };
          
          arrSumData.push(data);

          //start new sum for next receipt number
          sumBruto = 0; sumDiscount = 0; sumNetto = 0; sumTotal = 0;sumTax=0;sumPembulatan=0;

          sumBruto = sumBruto + parseInt(report[i].bruto);
          sumDiscount = sumDiscount + parseInt(report[i].disc);
          sumNetto = sumNetto + parseInt(report[i].netto);
          sumTotal = sumTotal + parseInt(report[i].total);
          sumTax = sumTax + parseInt(report[i].tax);
          sumPembulatan = sumPembulatan + parseInt(report[i].pembulatan);
          //end new sum for next receipt number
          receiptNumber = tempReceiptNumber;
        }
      }

        if(i === lastCount) {
          let indexInsert = i + receiptNumberCount + 1;
          let data = {
            id: '0',
            receipt_no: receiptNumber,
            sum_bruto: sumBruto,
            sum_discount: sumDiscount,
            sum_netto: sumNetto,
            sum_charge: sumCharge,
            sum_tax: sumTax,
            sum_pembulatan:sumPembulatan,
            sum_total: sumTotal,
            index_insert: indexInsert
          };
          arrSumData.push(data);
        }
      
    }
    
    let sumGtBruto: number = 0, sumGtDiscount: number = 0, sumGtNetto: number = 0, sumGtCharge: number = 0,
    sumGtTax: number = 0, sumGtTotal: number = 0,sumGtPembulatan=0;
    for(let x = 0; x < arrSumData.length; x++) {
      let indexInsert: number = arrSumData[x].index_insert;
      this.reportData.splice(indexInsert, 0, arrSumData[x]);
      sumGtBruto = sumGtBruto + parseInt(arrSumData[x].sum_bruto);
      sumGtDiscount = sumGtDiscount + parseInt(arrSumData[x].sum_discount);
      sumGtNetto = sumGtNetto + parseInt(arrSumData[x].sum_netto);
      sumGtTotal = sumGtTotal + parseInt(arrSumData[x].sum_total);
      sumGtTax = sumGtTax + parseInt(arrSumData[x].sum_tax);
      sumGtPembulatan = sumGtPembulatan + parseInt(arrSumData[x].sum_pembulatan);
    }

    let dataGt = {
      id: '00',
      receipt_no: '',
      sum_gt_bruto: sumGtBruto,
      sum_gt_discount: sumGtDiscount,
      sum_gt_netto: sumGtNetto,
      sum_gt_charge: sumGtCharge,
      sum_gt_tax: sumGtTax,
      sum_gt_total: sumGtTotal,
      sum_gt_pembulatan:sumGtPembulatan
    };
    this.reportData.push(dataGt);
  }

  countTotalReportTransactionBrand(report: any) {
    let brandId: any = '';
    this.sumQty =0;
    this.sumNetto =0;
    let sumQty: number = 0, sumNetto: number = 0, sumTax:number = 0,sumBruto:number=0, sumDisc:number=0, sumPembulatan:number=0, sumTotal:number=0;

    let brandIdCount: number = 0;
    let arrSumData: any[] = [];
    report.sort(function(a, b) {
      var textA = a.product_brand_name.toUpperCase();
      var textB = b.product_brand_name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    for(let i = 0; i < report.length; i++) {
      let tempbrandId = report[i].product_brand_id;
      if(i === 0) { brandId = report[i].product_brand_id; }
      if(brandId === tempbrandId) {
        sumQty = sumQty + parseInt(report[i].total_qty);
        sumNetto = sumNetto + parseInt(report[i].netto);
        sumTax = sumTax + parseInt(report[i].tax);
        sumPembulatan = sumPembulatan + parseInt(report[i].pembulatan);
        sumBruto = sumBruto + parseInt(report[i].bruto);
        sumDisc = sumDisc + parseInt(report[i].disc);
        sumTotal = sumTotal + parseInt(report[i].total);
      } else {
        let indexInsert = i + brandIdCount;
        brandIdCount = brandIdCount + 1;
        let data = {
          id: '0',
          product_brand_id: brandId,
          product_brand_name: report[i-1].product_brand_name,
          sum_qty: sumQty,
          sum_netto: sumNetto,
          sum_tax: sumTax,
          sum_pembulatan: sumPembulatan,
          sum_bruto:sumBruto,
          sum_disc:sumDisc,
          sum_total:sumTotal,
          index_insert: indexInsert
        };
        arrSumData.push(data);
        //start new sum for next counter
        sumQty = 0; sumNetto = 0; sumTax = 0;sumBruto=0;sumDisc=0;sumPembulatan=0;sumTotal=0;
        sumQty = sumQty + parseInt(report[i].total_qty);
        sumNetto = sumNetto + parseInt(report[i].netto);
        sumTax = sumTax + parseInt(report[i].tax);
        sumPembulatan = sumPembulatan + parseInt(report[i].pembulatan);
        sumBruto = sumBruto + parseInt(report[i].bruto);
        sumDisc = sumDisc + parseInt(report[i].disc);
        sumTotal = sumTotal +parseInt(report[i].total);
        //end new sum for next counter
        brandId = tempbrandId;
      }
      if(i==(report.length-1)){
        let indexInsert = i + brandIdCount+1;
        let data = {
          id: '0',
          product_brand_id: brandId,
          product_brand_name: report[i].product_brand_name,
          sum_qty: sumQty,
          sum_netto: sumNetto,
          sum_tax:sumTax,
          sum_pembulatan:sumPembulatan,
          sum_bruto:sumBruto,
          sum_disc:sumDisc,
          sum_total:sumTotal,
          index_insert: indexInsert
        };    
        arrSumData.push(data);
      }
    }
    for(let x = 0; x < arrSumData.length; x++) {
      let indexInsert: number = arrSumData[x].index_insert;
      this.reportData.splice(indexInsert, 0, arrSumData[x]);
      this.sumQty += arrSumData[x].sum_qty;
      this.sumNetto += arrSumData[x].sum_netto;
      this.sumTax += arrSumData[x].sum_tax;
      this.sumPembulatan += arrSumData[x].sum_pembulatan;
      this.sumBruto += arrSumData[x].sum_bruto;
      this.sumDiscount += arrSumData[x].sum_disc;
      this.sumTotal += arrSumData[x].sum_total;
    }
  }

  checkReceiptNo(receiptNumber: any, index: any) {
    if(index === 0) {
      this.tempReceiptNumber = receiptNumber;
      return true;
    } else {
      if(this.tempIndex === index) {
        if(this.tempReceiptNumber === receiptNumber) {
          return false;
        } else {
          return true;
        }
      } else {
        this.tempIndex = index;
        if(this.tempReceiptNumber === receiptNumber) {
          return false;
        } else {
          this.tempReceiptNumber = receiptNumber;
          return true;
        }
      }
    }
  }

  checkUserRoles(id: any, receiptNo: any) {
    if(this.roleAccess.delete === '1') {
      this.showInputPassword(id, receiptNo);
    } else {
      this.showNotifNotAuthorized('Anda tidak memiliki akses untuk melakukan Void !');
    }
  }

  saveVoidTransaction(id: any, receiptNo: any, descVoid: any) {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let body = {
        id: id,
        receipt_no: receiptNo,
        desc_void: descVoid,
        created_by: this.userProfile.username,
        updated_by: this.userProfile.username,
        void_reason_id:this.void_type_id,
        replacement_receipt:this.replacementReceipt
      };
      this.reportService.saveVoidTransaction(body).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showNotifAfterVoidTransaction(receiptNo);
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  setParamReport(branchId:any,counterId: any, cashierId: any, userId: any,
    transactionTypeId: any, rekapPer: any, periodStart: any, periodEnd: any, receiptNumber: any,
    typeId: any, resellerId: any,spgId:any) {
      this.paramBranchId = branchId;
      this.paramCounterId = counterId;
      this.paramCashierId = cashierId;
      this.paramUserId = userId;
      this.paramTransactionTypeId = transactionTypeId;
      this.paramRekapPer = rekapPer;
      this.paramPeriodStart = periodStart;
      this.paramPeriodEnd = periodEnd;
      this.paramReceiptNumber = receiptNumber;
      this.paramTypeId = typeId;
      this.paramResellerId = resellerId;
      this.paramSpgId=spgId;
  }

  async showConfirmVoidTransaction(id: any, receiptNo: any) {
    let notifMessage: any = '';
    if(receiptNo !== null) {
      notifMessage = 'Apakah anda yakin untuk melakukan void untuk transaksi dengan struk no. '+ receiptNo + ' ?';
    } else {
      let messageSetup: any = 'Sistem tidak dapat membaca nomor struk';
      this.toastCtrl.create({ duration: 2000, message: messageSetup }).then(t => t.present());
    }

    if(notifMessage !== '') {
      const alert = await this.alertController.create({
        header: 'Void Confirmation',
        cssClass:'custom-alert-class',
        message: notifMessage,
        buttons: [
          {
            text: 'Cancel',
            handler: () => {}
          },
          {
            text: 'OK',
            handler: () => {
              this.checkBeforeVoid(id, receiptNo);
            }
          }
        ]
      });
      await alert.present();
    }
  }
  async checkBeforeVoid(id: any, receiptNo: any) {
    this.void_type_id=0;
    this.replacementReceipt=0;
    const modal = await this.modalController.create({
      component: VoidTransactionComponent,
      componentProps: {
        "counterId": this.userProfile.counter_id_pos ? this.userProfile.counter_id_pos : 0,
        'token': this.token,
        'currentReceipt':receiptNo
      },
      backdropDismiss: false
    });
    modal.onDidDismiss().then((modelData) => {
      if (modelData !== null) {
        if(modelData.data.close_message=='valid'){
          this.void_type_id = Number(modelData.data.reason_type);
          this.replacementReceipt = Number(modelData.data.replacement_receipt_id);
          this.checkUserRoles(id, receiptNo);
        }
      }
    });
    return await modal.present();
  }

  async showNotifAfterVoidTransaction(receiptNo: any) {
    let notifMessage: any = 'Berhasil void transaksi struk no. ' + receiptNo;
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: notifMessage,
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.generateReport(
              this.paramBranchId,
              this.paramCounterId, this.paramCashierId, this.paramUserId, 
              this.paramTransactionTypeId, this.paramRekapPer, this.paramPeriodStart, 
              this.paramPeriodEnd, this.paramReceiptNumber, this.paramTypeId,
              this.paramResellerId, this.paramPaymentType,this.paramSpgId);
          }
        }
      ]
    });
    await alert.present();
  }

  async showInputPassword(id: any, receiptNo: any) {
    const alert = await this.alertController.create({
      header: 'Confirmation',
      subHeader: 'Verifikasi Password',
      message: 'Silahkan masukkan password kembali',
      inputs: [
        {
          name: 'password',
          placeholder: 'Password',
          type: 'password'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: () => {}
        },
        {
          text: 'OK',
          handler: (input: any) => {
            this.storage.get('user_password')
            .then((userPassword) => {
              if(input.password === userPassword) {
                this.showInputVoidReason(id, receiptNo);
              } else {
                this.showNotifNotAuthorized("Password yang anda masukkan salah!");
              }
            });
          }
        }
      ]
    });
    await alert.present();
  }

  async showInputVoidReason(id: any, receiptNo: any) {
    const alert = await this.alertController.create({
      header: 'Confirmation',
      subHeader: 'Keterangan Void',
      message: 'Silahkan masukkan keterangan void',
      inputs: [
        {
          name: 'voidReason',
          placeholder: 'Keterangan',
          type: 'text'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: () => {}
        },
        {
          text: 'OK',
          handler: (input: any) => {
            if(!input.voidReason){
                this.showNotifNotAuthorized("Alasan void harus diisi");
            }
            else{
              let descVoid = input.voidReason ? input.voidReason : 'Tanpa keterangan';
              this.saveVoidTransaction(id, receiptNo, descVoid);
            }
          }
        }
      ]
    });
    await alert.present();
  }

  async showNotifNotAuthorized(messageValue: any) {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: messageValue,
      buttons: [
        {
          text: 'OK',
          handler: () => {}
        }
      ]
    });
    await alert.present();
  }

  async showCounterList() {
    const modal = await this.modalController.create({
      component: ReportCashierCounterListComponent,
      componentProps: {
        counterList: this.counterListForShow
      },
      backdropDismiss: false
    });
    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      if (data !== 'null') {}
    });
    return await modal.present();
  }
  async showBranchList() {
    const modal = await this.modalController.create({
      component: ReportCashierBranchListComponent,
      componentProps: {
        branchList: this.branchListForShow
      },
      backdropDismiss: false
    });
    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      if (data !== 'null') {}
    });
    return await modal.present();
  }
  countTotalReportTransactionProduct(report: any) {
    this.sumQty = 0,  this.sumBruto=0,  this.sumDiscount =0 , this.sumNetto =0, this.sumTax=0, this.sumPembulatan=0; this.sumTotal=0;
    for(let i = 0; i < report.length; i++) {
      this.sumQty = this.sumQty + parseInt(report[i].qty);
      this.sumBruto = this.sumBruto + parseInt(report[i].bruto);
      this.sumDiscount = this.sumDiscount + parseInt(report[i].disc);
      this.sumNetto = this.sumNetto + parseInt(report[i].netto);
      this.sumTax = this.sumTax + parseInt(report[i].tax);
      this.sumPembulatan = this.sumPembulatan +parseInt(report[i].pembulatan);
      this.sumTotal = this.sumTotal +parseInt(report[i].total);
    }
  }
  async showConfirmSpecialVoidTransaction(id: any, receiptNo: any) {
    let notifMessage: any = '';
    if(receiptNo !== null) {
      notifMessage = 'Apakah anda yakin untuk melakukan void untuk transaksi dengan struk no. '+ receiptNo + ' ?';
    } else {
      let messageSetup: any = 'Sistem tidak dapat membaca nomor struk';
      this.toastCtrl.create({ duration: 2000, message: messageSetup }).then(t => t.present());
    }

    if(notifMessage !== '') {
      const alert = await this.alertController.create({
        header: 'Void Confirmation',
        cssClass:'custom-alert-class',
        message: notifMessage,
        buttons: [
          {
            text: 'Cancel',
            handler: () => {}
          },
          {
            text: 'OK',
            handler: () => {
              this.checkUserRoles(id, receiptNo);
            }
          }
        ]
      });
      await alert.present();
    }
  }
}